export default __webpack_public_path__ + "static/media/games.12cc1513.svg";